import EventEmitter from 'events'

import router from '@/router'
import axios from "@/axios.js"

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also

class AuthService extends EventEmitter {

    logOut() {
        console.log('logout');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userInfo');

        axios.post('/api/auth/logout')
        router.push('/login')
    }
}

export default new AuthService();